import styled from 'styled-components'
import Link from 'next/link'
import { useCourseWithSavedCoupon } from 'querys/course'
import { SecondaryButton } from 'common/button'
import DiscountTimer from 'common/banner/discount-timer'

const SinglePriceStyled = styled.div`
  .original-price {
    margin: 0;
    text-align: center;
  }
`

function SinglePrice() {
  const { data, isLoading } = useCourseWithSavedCoupon()

  if (!data || isLoading) return null

  const {
    slug, price: { amount, currency_code }, discount, original_price,
  } = data

  return (
    <SinglePriceStyled id="buy-course" className="buy-course">
      <div>
        <DiscountTimer
          discount={discount}
          alignSmall="center"
          align="center"
          color="var(--turquoise)"
          dataCy="single-price-timer"
        />
      </div>
      <div className="pricing-status">
        <div className="price-container">
          <p className="price" data-cy="subscription-price">
            $
            {amount}
            {' '}
            {currency_code}
          </p>
          {discount?.status === 'VALID' ? (
            <p className="original-price">
              $
              {original_price.amount}
              {' '}
              {currency_code}
            </p>
          ) : null}
        </div>
      </div>
      <Link href={`/comprar/cursos/${slug}`} passHref>
        <SecondaryButton id="buy-single-btn" fullWidth>
          Comprar curso
        </SecondaryButton>
      </Link>
      <a href="#comprar" className="options" id="buy-single-options">Ver opciones de pago</a>
    </SinglePriceStyled>
  )
}

export default SinglePrice
